import React from 'react'
import { Div } from 'ui'

const CircleColor = ({
  width= '30%',
  height= '60%',
  left,
  right,
  top,
  bottom,
  opacity = 0.2,
  zIndex = '-1',
  blur = 200,
  ...props
}) => {
  return (
    <Div
      position='absolute'
      width={width}
      height={height}
      top={top}
      bottom={bottom}
      left={left}
      right={right}
      z-index={zIndex}
      background='linear-gradient(225deg, #AC32E4 0%, #7918F2 47.87%, #4801FF 100%)'
      opacity={opacity}
      filter={`blur(${blur}px)`}
      transform='translate3d(0, 0, 0); // hack needed to blur works fine in iOS/safar'
      border-radius='50%'
      pointer-events='none'
      {...props}
    />
  )
}

export default CircleColor